export default __webpack_public_path__ + "static/media/login-bg-16.b1f2ffe5.jpg";